class o extends HTMLElement {
  constructor() {
    super(), (this.contentLoaded = !1), (this.endpoint = null);
  }
  connectedCallback() {
    this.endpoint = this.dataset.endpoint;
  }
  async loadContent() {
    if (this.contentLoaded) return;
    const n = await this.fetchContent();
    (this.innerHTML = n), (this.contentLoaded = !0);
  }
  async fetchContent() {
    const t = await (await fetch(this.endpoint)).json(),
      e = Object.keys(t)[0];
    return e ? t[e] : '';
  }
}
function i() {
  customElements.define('component-dynamic-modal-content', o);
}
export {i};
